import React from 'react';
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, IconButton, TablePagination, Box } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

type Device = {
  id: string;
  name: string;
  owner: string;
  type: string;
  status: string;
  updated: string;
};

interface Props {
  columns: { key: string; label: string }[];
  visibleColumns: Record<string, boolean>;
  rows: Device[];
  page: number;
  rowsPerPage: number;
  count: number;
  onEdit: (d: Device) => void;
  onDelete: (id: string) => void;
  onChangePage: (_: unknown, page: number) => void;
  onChangeRowsPerPage: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export default function DeviceTable({ columns, visibleColumns, rows, page, rowsPerPage, count, onEdit, onDelete, onChangePage, onChangeRowsPerPage }: Props) {
  return (
    <Box>
      <TableContainer sx={{ maxHeight: '58vh' }}>
        <Table size="medium">
          <TableHead>
            <TableRow sx={{ backgroundColor: '#1e1e1e' }}>
              {columns.map((c) => (visibleColumns[c.key] ? <TableCell key={c.key} sx={{ color: '#cfcfcf' }}>{c.label}</TableCell> : null))}
              <TableCell sx={{ color: '#cfcfcf' }}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((d) => (
              <TableRow key={d.id} hover sx={{ borderBottom: '1px solid rgba(255,255,255,0.03)', height: 64 }}>
                {columns.map((c) => (visibleColumns[c.key] ? <TableCell key={c.key} sx={{ color: '#ddd', fontSize: 14 }}>{(d as any)[c.key]}</TableCell> : null))}
                <TableCell>
                  <IconButton size="small" onClick={() => onEdit(d)}>
                    <EditIcon fontSize="small" />
                  </IconButton>
                  <IconButton size="small" onClick={() => onDelete(d.id)}>
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        component="div"
        count={count}
        page={page}
        onPageChange={onChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={onChangeRowsPerPage}
        rowsPerPageOptions={[10, 20, 30]}
        sx={{ color: '#bdbdbd' }}
      />
    </Box>
  );
}
